
import { hydrateCSRTemplate } from '@fiverr-private/layout-lib/CSRTemplate';
import { handleError } from '@fiverr-private/layout-lib/CSRTemplate/handleError';
import { loader } from '/home/circleci/app/packages/layout-footer-component/src/entries/LogoMakerLP';
const getRootElement = () => typeof document !== 'undefined' && document.querySelector('#Footer');
const lazyImport = () => import(
    /* webpackChunkName: "LogoMakerLPLazyComponent" */
    /* webpackExports: ["default"] */
    '/home/circleci/app/packages/layout-footer-component/src/entries/LogoMakerLP?version=1'
);
const hydrateComponent = async () => {
    try {
        const { default: Component } = await lazyImport();
        const props = window.initialData['Footer'];
        const root = getRootElement();
        if (root) {
            hydrateCSRTemplate(Component, props, root, 'Footer', 'LogoMakerLP');
        }
    } catch(error) {
        handleError(error, "Footer", "LogoMakerLP");
    }
};
const main = async () => {
    try {
        const root = getRootElement();
        if (root) {
            await loader(hydrateComponent, root);
        }
    } catch(error) {
        handleError(error, "Footer", "LogoMakerLP");
    }
};
main();
export default main;
